module.exports = __webpack_public_path__ + "static/media/FLA.77693d62.svg";